<div class="gt-workspace-root" [style.height]="isCeScreen ? '100%' : null">
  <div class="workspace-tpl clearfix">
    @if (workspaces?.length) {
<div class="ui-tabs-scrollable" [class.show-drop-down]="!hideDropDown">
      @if (!hideScrollButtons) {
<button type="button"
        class="btn nav-button left-nav-button"
       
        [disabled]="disableScrollLeft"
        (mousedown)="scrollButtonDown('left', $event)"
        (mouseup)="scrollButtonUp()"
        (mouseleave)="scrollButtonUp()"></button>
}
      <div class="spacer" [class.hidden-buttons]="hideScrollButtons">
        <div>
          <ul class="nav-tabs" #tabContainer (scroll)="onTabContainerScroll()">
            @for (workspace of workspaces; track $index) {
<li
                [ngClass]="{'active': state == workspace.id}"
                [attr.id]="workspace.screen_key"
                (click)="setTab(workspace, {})">
              <div class="cont-wrapper">
                @if (workspace.filter_inherit === 1) {
<i class="fa fa-link"></i>
}
                {{ workspace.label }}
                <i (click)="clearScreenCache($event, workspace)"
                   [ngClass]="{ cached: workspace.cachedData, loading_data: workspace.loading_data }"
                   class="fa fa-circle">
                </i>
              </div>
            </li>
}
          </ul>
        </div>
      </div>
      @if (!hideScrollButtons) {
<button type="button"
        class="btn nav-button right-nav-button"
       
        [disabled]="disableScrollRight"
        (mousedown)="scrollButtonDown('right', $event)"
        (mouseup)="scrollButtonUp()"
        (mouseleave)="scrollButtonUp()"></button>
}
      @if (!hideDropDown) {
<div class="btn-group dropdown" [class.open]="showDropdownMenu">
        <button type="button" class="btn dropdown-toggle" (click)="toggleDropdown($event)"></button>
        <ul class="dropdown-menu dropdown-menu-right scrollable-tabs" role="menu">
          @for (tab of dropdownTabs; track $index) {
<li
              [ngClass]="{'active': state == tab.id}"
              (click)="activateDropdownTab(tab)">
            <a>{{ tab.label }}</a>
          </li>
}
        </ul>
      </div>
}
    </div>
}
  </div>

  <div class="clearfix"></div>

  @if (!hideDataFilters) {
<gtw-data-filters></gtw-data-filters>
}

  <!--
    Legacy-only screens that had their filter panel declared inline in the
    AngularJS template (e.g. Tax Payer Review / Maintenance) — rendered here at
    shell level so the user can always change filters, even when the grid
    container is hidden by `gt-grid-hidden` after an empty fetch.
  -->
  @if (legacyFilterTag === 'gtw-submission-list-filter') {
<gtw-submission-list-filter>
  </gtw-submission-list-filter>
}

  @if (!isCeScreen) {

    <gtw-grid-import-toolbar></gtw-grid-import-toolbar>

    <!-- <div *ngIf="isEnable" class="back-button" (click)="backToPreviousScr()">
      <i class="fa fa-arrow-left"></i> {{ backMessage }}
    </div> -->

    @if (!dataFetched && !gridLoading) {
<div class="gt-no-data-placeholder">
      <img src="assets/img/arrow-filter-sm.png" alt="Filter" class="gt-placeholder-img">
    </div>
}

    @if (gridLoading) {
<div class="gt-grid-loading-overlay">
      <i class="fa fa-spinner fa-spin"></i>
      <span>Loading...</span>
    </div>
}
  
}

  <div [class.gt-grid-hidden]="!isCeScreen && (!dataFetched || gridLoading)" [style.height]="isCeScreen ? '100%' : null">
    <router-outlet></router-outlet>
  </div>
</div>
